import React, { useRef, useEffect, useState, useMemo } from "react";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import { Link, useLocation, useNavigate } from "react-router-dom";
import JoditEditor from "jodit-react";
import axios from "axios";
import api from "../helper/api";
import Cropper from "react-easy-crop";
import getCroppedImg from "../helper/cropImage";

export default function EditDealerCar() {
  const navigate = useNavigate();
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [currentMileage, setCurrentMileage] = useState("");
  const [fixedPrice, setFixedPrice] = useState("");
  const config = useMemo(
    () => ({
      height: 400,
      toolbarAdaptive: false,
      buttons: [
        "bold",
        "italic",
        "underline",
        "|",
        "ul",
        "ol",
        "|",
        "font",
        "|",
        "align",
        "|",
        "link",
        "unlink",
        "fontsize",
      ],

      allowTabNavigation: true,
      saveModeInStorage: false,
      disablePlugins: ["pasteStorage"],
      readonly: false,
      enableDragAndDropFileToEditor: true,
      uploader: { insertImageAsBase64URI: true },
      placeholder: "",
    }),
    []
  );
  const editor = useRef(null);
  const [specifications, setSpecifications] = useState("");
  const [loading, setLoading] = useState(false);
  const [images, setImages] = useState([]);
  const [tel, setTel] = useState("");
  const [email, setEmail] = useState("");
  const [carData, setCarData] = useState([]);
  const [postcode, setPostcode] = useState("");
  const [car, setCarOldData] = useState([]);
  const [isCarData, setCarDataAv] = useState(false);
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [model_varient, setModelVarient] = useState("");
  const [year, setYear] = useState("");
  const [fuel_type, setFuelType] = useState("");
  const [color, setColor] = useState("");
  const [body_type, setBodyType] = useState("");
  const [transmission_type, setTransmissionType] = useState("");
  const [seating_capacity, setSeatingCapacity] = useState("");
  const [batteryCapacity, setBatteryCapacity] = useState("");
  const [electricRange, setElectricRange] = useState("");
  const [checking, setChecking] = useState(false);
  const [isCarAccept, setIsCarAccept] = useState(true);
  const [preview, setPreview] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isAbleSubmit, setIsAbleSubmit] = useState(false);
  const [errors, setErrors] = useState({
    mileage: "",
    email: "",
    phone: "",
    postcode: "",
  });

  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  const [cropMode, setCropMode] = useState("preview");
  const [galleryQueue, setGalleryQueue] = useState([]);

  useEffect(() => {
    if (galleryQueue.length > 0 && !showCropModal) {
      const nextFile = galleryQueue[0];
      setSelectedFileName(nextFile.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setCropMode("gallery");
        setShowCropModal(true);
      };
      reader.readAsDataURL(nextFile);
    }
  }, [galleryQueue, showCropModal]);
  const location = useLocation();

  //   console.log(data);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
    const { data } = location.state;
    setCarOldData(location.state.data);
    setRegistrationNumber(data?.registration_number);
    setCurrentMileage(data?.current_mileage);
    setFixedPrice(data?.offer_price);
    setEmail(data?.email);
    setTel(data?.phone);
    setSpecifications(data?.specifications);
    setBodyType(data?.body_type);
    setColor(data?.color);
    setFuelType(data?.fuel_type);
    setYear(data?.year);
    setMake(data?.make);
    setModel(data?.model);
    setPostcode(data?.postcode);
    setModelVarient(data?.model_varient);
    setSeatingCapacity(data?.seating_capacity);
    setTransmissionType(data?.transmission_type);
    setBatteryCapacity(data?.battery_capacity || "");
    setElectricRange(data?.electric_range || "");
  }, []);

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length > 0) {
      setGalleryQueue((prev) => [...prev, ...selectedFiles]);
    }
  };
  const removeImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const updateCarInList = () => {
    if (registrationNumber === car?.registration_number) {
      const formData = {
        car_id: car?.id,
        owner_id: storedUserPreferences?.id,
        registration_number: registrationNumber,
        fixed_price: fixedPrice,
        make: make,
        model: model,
        postcode: postcode,
        model_varient: model_varient,
        year: year,
        fuel_type: fuel_type,
        body_type: body_type,
        transmission_type: transmission_type,
        color: color,
        seating_capacity: seating_capacity,
        specifications: specifications,
        phone: tel,
        email: email,
        latitude: 40.7128,
        longitude: -74.006,
        images: images,
        previewImg: previewImg,
        current_mileage: currentMileage,
        battery_capacity: batteryCapacity,
        electric_range: electricRange,
      };

      axios
        .post(
          window.CARLOCA_API + "/dealer/car/update",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          // console.log(res?.data);
          setLoading(false);

          if (res?.data?.status) {
            setRegistrationNumber("");
            setCurrentMileage("");
            setFixedPrice("");
            setSpecifications("");
            setImages([]);
            setModelVarient("");
            navigate("/thankyou", { state: { data: res?.data }, replace: true });
            setCarDataAv(false);
          } else {
            toast.error(res?.data?.message, optionToast);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } else {
      if (!isCarAccept) {
        if (isCarData) {
          const formData = {
            car_id: car?.id,
            owner_id: storedUserPreferences?.id,
            registration_number: registrationNumber,
            fixed_price: fixedPrice,
            make: make,
            postcode: postcode,
            model: model,
            model_varient: model_varient,
            year: year,
            fuel_type: fuel_type,
            body_type: body_type,
            transmission_type: transmission_type,
            color: color,
            seating_capacity: seating_capacity,
            specifications: specifications,
            phone: tel,
            email: email,
            latitude: 40.7128,
            longitude: -74.006,
            images: images,
            current_mileage: currentMileage,
            battery_capacity: batteryCapacity,
            electric_range: electricRange,
          };

          axios
            .post(
              window.CARLOCA_API + "/dealer/car/update",
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              // console.log(res?.data);
              setLoading(false);

              if (res?.data?.status) {
                setRegistrationNumber("");
                setCurrentMileage("");
                setFixedPrice("");
                setSpecifications("");
                setImages([]);
                navigate("/thankyou", { state: { data: res?.data }, replace: true });
                setCarDataAv(false);
              } else {
                toast.error(res?.data?.message, optionToast);
              }
            })
            .catch((err) => {
              setLoading(false);
              console.log(err);
            });
        } else {
          setLoading(false);
          setIsAbleSubmit(true);
          toast.error(
            "Please verify your car registration number!",
            optionToast
          );
        }
      } else {
        toast.error("Please accept this car is your?");
      }
    }
  };
  const getCarData = () => {
    setChecking(true);
    setIsAbleSubmit(true);
    
    api
      .get("/vehicle/" + registrationNumber)
      .then((res) => {
        setChecking(false);
        if (res?.data?.status) {
          const results = res?.data?.response?.Results;
          const vehicleId = results?.VehicleDetails?.VehicleIdentification;
          const modelDetails = results?.ModelDetails;
          const history = results?.VehicleDetails?.VehicleHistory;
          
          setMake(vehicleId?.DvlaMake);
          setModel(vehicleId?.DvlaModel);
          setModelVarient(modelDetails?.ModelIdentification?.ModelVariant || vehicleId?.DvlaModel || "Standard");
          setBodyType(modelDetails?.BodyDetails?.BodyStyle || vehicleId?.DvlaBodyType || "Unknown");
          setFuelType(modelDetails?.Powertrain?.FuelType || vehicleId?.DvlaFuelType);
          setColor(history?.ColourDetails?.CurrentColour || history?.ColourDetails?.OriginalColour || "Unknown");
          setTransmissionType(modelDetails?.Powertrain?.Transmission?.TransmissionType || (vehicleId?.DvlaModel?.toLowerCase().includes("auto") ? "Automatic" : "Manual"));
          setYear(vehicleId?.YearOfManufacture);
          setSeatingCapacity(modelDetails?.BodyDetails?.NumberOfSeats || results?.VehicleDetails?.DvlaTechnicalDetails?.NumberOfSeats || "5");
          setBatteryCapacity(modelDetails?.Powertrain?.TotalCapacityKwh || modelDetails?.Powertrain?.EvDetails?.TechnicalDetails?.BatteryDetailsList?.[0]?.TotalCapacityKwh || "");
          setElectricRange(modelDetails?.Powertrain?.CombinedRangeMiles || modelDetails?.Powertrain?.ElectricRangeMiles || modelDetails?.Powertrain?.EvDetails?.Performance?.RangeFigures?.RangeTestCycleList?.[0]?.CombinedRangeMiles || "");
          setCarDataAv(true);
          setIsCarAccept(true);
        } else {
          setCarDataAv(false);
          setIsCarAccept(true);
          setIsAbleSubmit(true);
          setMake("");
          setModel("");
          setModelVarient("");
          setBodyType("");
          setFuelType("");
          setBatteryCapacity("");
          setElectricRange("");
          setColor("");
          setTransmissionType("");
          setYear("");
          setSeatingCapacity("");
          
          
          
          if (typeof toast !== 'undefined' && typeof optionToast !== 'undefined') {
            toast.error(res?.data?.message || "Registration number not found!", optionToast);
          } else if (typeof toast !== 'undefined') {
            toast.error(res?.data?.message || "Registration number not found!");
          }
        }
      })
      .catch((err) => {
        setChecking(false);
        console.log(err);
        if (typeof toast !== 'undefined' && typeof optionToast !== 'undefined') {
          toast.error("Failed to fetch car data.", optionToast);
        }
      });
  };
  const isCarRegistrationExist = () => {
    setChecking(true);
    var car_id = car["id"];
    const formData = {
      registration_number: registrationNumber,
      id: car_id,
    };
    axios
      .post(
        window.CARLOCA_API + "/car/data",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        setChecking(false);
        if (res?.data?.code === 101) {
          getCarData();
        } else {
          toast.error(res?.data?.message, optionToast);
          setChecking(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!registrationNumber) {
      toast.error("Please fill in the registration number.", optionToast);
      return;
    }
    if (!currentMileage) {
      toast.error("Please fill in the current mileage.", optionToast);
      return;
    }
    if (!fixedPrice) {
      toast.error("Please fill in the fixed price.", optionToast);
      return;
    }

    if (!specifications) {
      toast.error("Please fill in the specifications.", optionToast);
      return;
    }
    setLoading(true);
    updateCarInList();
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const closeCropModal = () => {
    setShowCropModal(false);
    setImageSrc(null);
    if (cropMode === "gallery") {
      setGalleryQueue((prev) => prev.slice(1));
    }
  };

  const handleCropImage = async () => {
    try {
      const croppedImageBlob = await getCroppedImg(imageSrc, croppedAreaPixels);
      const croppedFile = new File([croppedImageBlob], selectedFileName || "cropped_image.jpg", {
        type: "image/jpeg",
      });
      if (cropMode === "preview") {
        setPreviewImg(croppedFile);
        setPreview(URL.createObjectURL(croppedImageBlob));
      } else {
        setImages((prev) => [...prev, croppedFile]);
      }
      closeCropModal();
    } catch (error) {
      console.error("Error cropping image:", error);
    }
  };

  const handlePreviewImgChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageSrc(reader.result);
        setCropMode("preview");
        setShowCropModal(true);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleDeleteImage = async (imageId) => {
    const formData = {
      image_id: imageId,
    };
    try {
      await axios
        .post(
          `${window.CARLOCA_API}/car/delete/gallery`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((response) => {
          if (response?.data?.status) {
            setCarOldData((prevCar) => ({
              ...prevCar,
              gallery: prevCar.gallery.filter(
                (carImage) => carImage.id !== imageId
              ),
            }));
            toast.success("Image deleted successfully", optionToast);
          } else {
            toast.error(response?.data?.message, optionToast);
          }
        });
    } catch (error) {
      console.error("Error deleting the image", error);
      alert("Failed to delete image");
    }
  };
  const validateMileage = (value) => {
    if (/^\d*$/.test(value)) {
      setErrors((prev) => ({ ...prev, mileage: "" }));
      setCurrentMileage(value);
    } else {
      setErrors((prev) => ({
        ...prev,
        mileage: "Please enter a valid current mileage (Like 20, 39, etc).",
      }));
    }
  };
  const validatePostcode = (value) => {
    setErrors((prev) => ({
      ...prev,
      postcode: "",
    }));
    setPostcode(value); // updates input
  };
  return (
    <>
      <Navbar />
      <div className="new_page w-100 container-fluid">
        <div className="list_details add_car_container row  shadow-0  p-sm-4 p-0 mb-5 d-flex flex-column justify-content-center align-items-center">
          <form
            action=""
            className="col-md-8 d-flex flex-column justify-content-center mt-5"
          >
            <div className="row border-0 pb-0">
              <div className="col-md-12">
                <div className="ps-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h4 className="fs-4 fw-semibold mt-2 poppins-semibold">
                      Edit Your Car
                    </h4>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(-1);
                      }}
                      className="btn btn-sm rounded-1 py-1 px-3 btn-primary text-white fw-semibold"
                    >
                      Back
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="search-main p-0  mt-md-3 mt-3">
              <div
                className="card glassmorphism-1 "
                style={{ boxShadow: "none !important" }}
              >
                <div className="card-body   w-100 d-flex align-items-center justify-content-around">
                  <div className="input-group py-1  ">
                    <input
                      type="text"
                      placeholder="Enter Reg Here"
                      name="registration"
                      id="registration"
                      className="form-control form-control-lg"
                      value={registrationNumber}
                      onChange={(e) => {
                        setRegistrationNumber(e.target.value);
                        if (e.target.value === car?.registration_number) {
                          setIsAbleSubmit(false);
                        } else {
                          setIsAbleSubmit(true);
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={isCarRegistrationExist}
                      disabled={checking}
                      className="decided-btn input-group-btn"
                    >
                      {checking ? "Checking..." : "Check"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {isCarData && (
              <div className="col-md-12 ">
                <div className="row border-0 justify-content-center">
                  <div className="col-sm-12 col-md-8">
                    <div className="ps-2">
                      <h4 className="fs-4 fw-semibold mt-5 mb-3 poppins-semibold">
                        Is This Your Car?
                      </h4>
                    </div>
                    <div className="card glassmorphism-1 ">
                      <div className="card-body p-md-5 p-3">
                        <div className="card border-0 rounded-3 shadow-lg">
                          <div className="card-body card_detail_list">
                            <ul>
                              <li>
                                <span className="list-heading">Make:</span>
                                <span className="list-text">{make}</span>
                              </li>
                              <li>
                                <span className="list-heading">Model:</span>
                                <span className="list-text">{model}</span>
                              </li>
                              <li>
                                <span className="list-heading">Year:</span>
                                <span className="list-text">{year}</span>
                              </li>
                              <li>
                                <span className="list-heading">Colour:</span>
                                <span className="list-text">{color}</span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {isCarAccept && (
                          <div className="d-flex mt-3 justify-content-around">
                            <button
                              type="button"
                              className="decided-btn"
                              onClick={() => {
                                setIsCarAccept(false);
                                toast.success(
                                  "Thanks for confirmation.",
                                  optionToast
                                );
                                setIsAbleSubmit(false);
                                const infoElement =
                                  document.querySelector("#info_about");
                                if (infoElement) {
                                  infoElement.scrollIntoView({
                                    behavior: "smooth",
                                  });
                                }
                              }}
                            >
                              Yes
                            </button>
                            <button
                              type="button"
                              className="decided-btn"
                              onClick={() => {
                                setCarDataAv(false);
                              }}
                            >
                              No
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Postcode Field */}
            <h5 className="py-3 fw-bolder mt-5">Car Location</h5>
            <div className="row">
              <div className="col-md-12 mb-0">
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder="Postcode"
                    value={postcode}
                    onChange={(e) => validatePostcode(e.target.value)}
                    style={{
                      borderColor: errors.postcode ? "red" : "",
                    }}
                  />

                  <i className="fa-solid fa-location-dot"></i>
                </div>
                {errors.postcode && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {errors.postcode}
                  </div>
                )}
                <small className="text-muted mb-0">
                  This is where potential buyers will view your car
                </small>
              </div>
            </div>
            <h3 className="py-3">About The Car</h3>
            <div className="row">
              <div className="col-md-6 mb-3">
                <input
                  type="text"
                  placeholder="Current Mileage"
                  value={currentMileage}
                  onChange={(e) => validateMileage(e.target.value)}
                  style={{
                    borderColor: errors.mileage ? "red" : "",
                  }}
                />
                {errors.mileage && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {errors.mileage}
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <input
                  type="number"
                  step="0.01"
                  min={1}
                  className="form-control"
                  aria-label="Fixed Price"
                  placeholder="Fixed Price"
                  value={fixedPrice}
                  onChange={(e) => setFixedPrice(e.target.value)}
                />
              </div>

              {(fuel_type?.toLowerCase().includes("electric") || fuel_type?.toLowerCase().includes("hybrid") || fuel_type?.toLowerCase().includes("bi fuel")) && (
                <>
                  <div className="col-md-6 mb-3">
                    <label className="mb-1" style={{ fontWeight: "500" }}>Battery Capacity (kWh)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="e.g. 27.5"
                      value={batteryCapacity}
                      onChange={(e) => setBatteryCapacity(e.target.value)}
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="mb-1" style={{ fontWeight: "500" }}>Electric Range (mi)</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      placeholder="e.g. 93"
                      value={electricRange}
                      onChange={(e) => setElectricRange(e.target.value)}
                    />
                  </div>
                </>
              )}

              <div className="col-12 mb-3 jd-editor">
                <JoditEditor
                  ref={editor}
                  value={specifications}
                  config={config}
                  onBlur={(newContent) => setSpecifications(newContent)}
                />
              </div>
              <h5>Preview Image</h5>
              <div className="col-sm-4 col-6 ">
                <img
                  src={
                    preview
                      ? preview
                      : `${window.CARLOCA_UPLOADS}/cars/${car?.image}`
                  }
                  alt=""
                  style={{ width: "100%" }}
                  className="rounded-2"
                />
                <label
                  className="btn my-2 btn-primary btn-sm "
                  htmlFor="prevfile"
                  disabled={uploading}
                >
                  <i className="fa fa-edit"></i>
                </label>
                {uploading && <p>Uploading...</p>}
                <input
                  id="prevfile"
                  className="d-none"
                  type="file"
                  name="prevfile"
                  accept="image/*"
                  onChange={handlePreviewImgChange}
                />
              </div>

              <h5 className="my-3">Gallery Images</h5>
              {car?.gallery != null && car?.gallery !== undefined
                ? car?.gallery.map((carimage) => (
                  <div className="col-sm-4 col-6 " key={carimage.id}>
                    <img
                      src={`${window.CARLOCA_UPLOADS}/cars-gallery/${carimage?.image}`}
                      alt=""
                      style={{ width: "100%" }}
                      className="rounded-2"
                    />
                    <button
                      type="button"
                      className="btn my-2 btn-danger btn-sm "
                      onClick={() => handleDeleteImage(carimage?.id)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                ))
                : ""}

              <div className="col-12 mb-3">
                <div className="border text-center bg-white py-5">
                  <input
                    id="upload"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: "none" }}
                  />
                  <label htmlFor="upload">
                    <img
                      style={{ width: "80px", cursor: "pointer" }}
                      src="/img/gallery_icon.png"
                      alt=""
                    />
                    <p>Upload Gallery Images</p>
                  </label>
                </div>
              </div>

              <div className="col-12 mb-3">
                {images.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      display: "inline-block",
                      position: "relative",
                      marginRight: "10px",
                    }}
                  >
                    <img
                      src={URL.createObjectURL(image)}
                      alt={`Image ${index + 1}`}
                      style={{ width: "100px" }}
                    />
                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => removeImage(index)}
                      style={{ position: "absolute", top: "5px", right: "5px" }}
                    >
                      X
                    </button>
                  </div>
                ))}
              </div>

              <div className="d-flex mt-4 justify-content-center flex-column align-items-center">
                <button
                  onClick={handleSubmit}
                  className="btn btn-primary text-center"
                  disabled={isAbleSubmit || loading} // Disable button during loading
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Uploading...
                    </>
                  ) : (
                    "List My Car"
                  )}
                </button>
                <small className="text-primary mt-2">
                  {isAbleSubmit ? "Please verify your reg no." : ""}
                </small>
              </div>
            </div>
          </form>
        </div>
      </div>
      <Footer />
      {showCropModal && (
        <div className="modal fade show" tabIndex="-1" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Crop Your Photo</h5>
                <button type="button" className="btn-close" onClick={closeCropModal}></button>
              </div>
              <div className="modal-body">
                <div style={{ position: "relative", height: "300px", width: "100%" }}>
                  <Cropper
                    image={imageSrc}
                    crop={crop}
                    zoom={zoom}
                    aspect={4 / 3}
                    minZoom={1}
                    maxZoom={3}
                    restrictPosition={true}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
                <div className="mt-3 px-2">
                  <label className="form-label fs-6 fw-semibold mb-1">Zoom Control</label>
                  <div className="d-flex align-items-center gap-2">
                    <i className="fa-solid fa-magnifying-glass-minus text-muted"></i>
                    <input
                      type="range"
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      aria-label="Zoom"
                      onChange={(e) => setZoom(parseFloat(e.target.value))}
                      className="form-range flex-grow-1"
                    />
                    <i className="fa-solid fa-magnifying-glass-plus text-muted"></i>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary btn-sm" onClick={closeCropModal}>Cancel</button>
                <button className="btn btn-primary btn-sm" onClick={handleCropImage}>
                  <i className="fa-solid fa-crop me-1"></i>Crop &amp; Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
}
